'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'share-nodes';
var width = 448;
var height = 512;
var aliases = ["share-alt"];
var unicode = 'f1e0';
var svgPathData = 'M448 112c0 44.2-35.8 80-80 80c-25.9 0-48.9-12.3-63.5-31.3L157.1 234.4c1.9 6.9 2.9 14.1 2.9 21.6s-1 14.7-2.9 21.6l147.5 73.7c14.6-19 37.6-31.3 63.5-31.3c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-12.6 2.9-24.5 8.1-35L151.2 292.5C137.9 318.3 111 336 80 336c-44.2 0-80-35.8-80-80s35.8-80 80-80c31 0 57.9 17.7 71.2 43.5L296.1 147c-5.2-10.6-8.1-22.5-8.1-35c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM432 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM368 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faShareNodes = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;